import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=a80ee646&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=a80ee646&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ee646",
  null
  
)

export default component.exports